import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorsService } from 'app/services/validators/validators.service';
import { Router } from '@angular/router';
import { GetCardInfoForm } from '../../models/forms';
import { UtilityService } from 'app/services/utility/utility.service';
import { ChargeHttpService } from '../../../../services/api/charge-http.service';
import { CardInfoDataService } from '../../../../services/data/card-info-data.service';
import { HttpError } from 'app/static/http-error';
import { GetCardInfoResponse } from '../../models/api-response';
import { SnackbarService } from 'app/services/snackbar/snackbar.service';
import { API_RESPONSE_CODES } from 'app/static/api';

@Component({
  selector: 'app-destination-account',
  templateUrl: './destination-account.component.html',
  styleUrls: ['./destination-account.component.scss']
})
export class DestinationAccountComponent implements OnInit {

  form: FormGroup;

  isSubmitting: boolean;

  constructor(
    private readonly cardInfoDataService: CardInfoDataService,
    private readonly validators: ValidatorsService,
    private readonly chargeHttp: ChargeHttpService,
    private readonly snackbar: SnackbarService,
    private readonly formBuilder: FormBuilder,
    private readonly utility: UtilityService,
    private readonly router: Router
  ) { }

  ngOnInit() {
    this.initForm();
  }


  onSubmit(): void {
    if (this.form.valid) {
      this.isSubmitting = true;
      this.form.disable();

      
      const form = <GetCardInfoForm>this.form.getRawValue();
      
      form.cardno = this.utility.removeDashFromCreditCard(form.cardno);
      let pin = form.cardno.slice(0,6)
      if(pin === "141272" || pin === "112210") {

        this.getCardInfo(form);
      } else {
        this.snackbar.default("شماره کارت وارد شده صحیح نمی باشد");
        this.isSubmitting = false
        this.form.enable()
      }
    }
  }


  private getCardInfo(form: GetCardInfoForm) {
    this.chargeHttp.getCardInfo(form)
      .subscribe(
        res => this.onGetCardInfoResponse(res),
        (err: HttpError) => this.onGetCardInfoError(err),
        () => this.onGetCardInfoSubscriptionComplete()
      )
  }


  private onGetCardInfoResponse(res: GetCardInfoResponse): void {
    if (res.status === API_RESPONSE_CODES.SUCCESS) {
      this.cardInfoDataService.setCardInfo(res.data);
      this.router.navigate(['payment-info', res.data.cardno]);
    } else {
      this.snackbar.default(res.message);
    }
  }


  private onGetCardInfoError(err: HttpError): void {
    this.snackbar.default(err.message);
    this.isSubmitting = false;
    this.form.enable();
  }


  private onGetCardInfoSubscriptionComplete(): void {
    this.isSubmitting = false;
    this.form.enable();
  }


  private initForm() {
    this.form = this.formBuilder.group({
      cardno: ['', Validators.compose([Validators.required])]
    });
  }
}
